import type { Concept, Annotation, Note } from '@verantos-dev/core-annotation-tool';
import {
  useNoteSectionCore,
  type UseNoteSectionCoreResult,
} from '@verantos-dev/core-annotation-tool';

import {
  addPendingSpan,
  addHighlightedTextSpan,
  clearAddEvidenceModeForConceptId,
} from '../../state/annotationSlice';
import {
  selectAddEvidenceModeForConceptId,
  selectHighlightedTextSpans,
  selectPendingSpansForAnnotation,
  selectSelectedNoteId,
} from '../../state/selector';

export type UseNoteSectionResult = UseNoteSectionCoreResult;

interface UseNoteSectionProps {
  concepts: Concept[] | null;
  annotations: Annotation[] | null;
  selectedNote: Note | null;
}

export const useNoteSection = ({
  concepts,
  annotations,
  selectedNote,
}: UseNoteSectionProps): UseNoteSectionResult => {
  return useNoteSectionCore({
    concepts,
    annotations,
    selectedNote,
    selectors: {
      selectAddEvidenceModeForConceptId,
      selectHighlightedTextSpans,
      selectPendingSpansForAnnotation,
      selectSelectedNoteId,
    },
    actions: {
      addPendingSpan,
      addHighlightedTextSpan,
      clearAddEvidenceModeForConceptId,
    },
  });
};
